import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import NavBar from './components/NavBar';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import FAQ from './pages/FAQ';
import AdminPanel from './components/AdminPanel';
import UserManagement from './pages/UserManagement';
import PlayerManagement from './pages/PlayerManagement';
import SquareManagement from './pages/SquareManagement';
import EmailClients from './components/EmailClients';
import ContactUs from './components/ContactUs';
import LoginModal from './components/LoginModal';
import Success from './pages/Success';
import GenerateRandomNumbers from './components/GenerateRandomNumbers';
import GeneratePDF from './components/GeneratePDF';
import AddTeams from './components/AddTeams';
import PriceManagement from './components/PriceManagement'; // Import the PriceManagement component
import NotFound from './pages/NotFound'; // Custom 404 page

// Wrapper for protecting admin routes
const AdminRoute = ({ isAdminLoggedIn, children }) => {
    return isAdminLoggedIn ? children : <Navigate to="/" />;
};

function App() {
    const [isLoginModalOpen, setIsLoginModalOpen] = React.useState(false);
    const [isAdminLoggedIn, setIsAdminLoggedIn] = React.useState(
        !!localStorage.getItem('token')
    );

    const handleLogin = () => {
        setIsAdminLoggedIn(true);
        setIsLoginModalOpen(false);
    };

    const handleLogout = () => {
        localStorage.removeItem('token');
        setIsAdminLoggedIn(false);
    };

    return (
        <Router>
            <NavBar
                isAdminLoggedIn={isAdminLoggedIn}
                onLoginClick={() => setIsLoginModalOpen(true)}
                onLogoutClick={handleLogout}
            />
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/faq" element={<FAQ />} />
                <Route path="/success" element={<Success />} />
                <Route
                    path="/admin"
                    element={
                        <AdminRoute isAdminLoggedIn={isAdminLoggedIn}>
                            <AdminPanel />
                        </AdminRoute>
                    }
                />
                <Route
                    path="/admin/players"
                    element={
                        <AdminRoute isAdminLoggedIn={isAdminLoggedIn}>
                            <PlayerManagement />
                        </AdminRoute>
                    }
                />
                <Route
                    path="/admin/price"
                    element={
                        <AdminRoute isAdminLoggedIn={isAdminLoggedIn}>
                            <PriceManagement />
                        </AdminRoute>
                    }
                />
                <Route
                    path="/admin/generate-random-numbers"
                    element={
                        <AdminRoute isAdminLoggedIn={isAdminLoggedIn}>
                            <GenerateRandomNumbers />
                        </AdminRoute>
                    }
                />
                <Route
                    path="/admin/generate-pdf"
                    element={
                        <AdminRoute isAdminLoggedIn={isAdminLoggedIn}>
                            <GeneratePDF />
                        </AdminRoute>
                    }
                />
                <Route
                    path="/admin/users"
                    element={
                        <AdminRoute isAdminLoggedIn={isAdminLoggedIn}>
                            <UserManagement />
                        </AdminRoute>
                    }
                />
                <Route
                    path="/admin/squares"
                    element={
                        <AdminRoute isAdminLoggedIn={isAdminLoggedIn}>
                            <SquareManagement />
                        </AdminRoute>
                    }
                />
                <Route
                    path="/admin/email-clients"
                    element={
                        <AdminRoute isAdminLoggedIn={isAdminLoggedIn}>
                            <EmailClients />
                        </AdminRoute>
                    }
                />
                <Route
                    path="/board/add-teams"
                    element={
                        <AdminRoute isAdminLoggedIn={isAdminLoggedIn}>
                            <AddTeams />
                        </AdminRoute>
                    }
                />
                <Route path="/contact" element={<ContactUs />} />
                <Route path="*" element={<NotFound />} /> {/* Custom 404 page */}
            </Routes>
            <Footer />
            <LoginModal
                isOpen={isLoginModalOpen}
                onRequestClose={() => setIsLoginModalOpen(false)}
                onLogin={handleLogin}
            />
        </Router>
    );
}

export default App;
